const projectImagePath = "assets/projectMedia/";

const projects = [
	{
		title: "ACTIV",
		desc: "ACTIV is a fitness and sports-focused social media app that distributes fitness advice from professionals to less-experienced gym-goers and athletes. The app uses machine learning to analyse and label videos with the exercises being performed within them. PTs can track their clients using messaging and dedicated client overview pages.",
		github: "https://github.com/alvin-agidi/3rdYrProject",
		tags: [
			"React Native",
			"Expo",
			"TypeScript",
			"Python",
			"TensorFlow",
			"Flask",
		],
		image: projectImagePath + "activ.png",
	},
	{
		title: "CodeLux",
		desc: "CodeLux is a system which can monitor software projects and advise whether a software project is likely to fail. This project is necessary as software underpins many functions in society today, and projects are often costly, so a tool is needed to ensure that software projects can succeed.",
		tags: ["Svelte", "SvelteKit", "TypeScript", "Python", "Tailwind"],
		github: "https://github.com/alvin-agidi/CodeLux",
		image: "https://github.com/alvin-agidi/CodeLux/assets/63751335/a2a966db-78c5-482c-8d44-920b376646d4",
	},
	{
		title: "Personal page",
		desc: "This personal page",
		tags: ["React", "JavaScript", "GitHub Pages"],
		github: "https://github.com/alvin-agidi/alvin-agidi.github.io",
	},
];

export default projects;
